import { render, staticRenderFns } from "./MagicZoom.vue?vue&type=template&id=58950ed9&"
import script from "./MagicZoom.vue?vue&type=script&lang=js&"
export * from "./MagicZoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/benutzer/Desktop/plentyMarkets/48470/400/Phywe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58950ed9')) {
      api.createRecord('58950ed9', component.options)
    } else {
      api.reload('58950ed9', component.options)
    }
    module.hot.accept("./MagicZoom.vue?vue&type=template&id=58950ed9&", function () {
      api.rerender('58950ed9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/phywe/MagicZoom.vue"
export default component.exports